export const POLL_INTERVAL_MS = 3000;
export const POLL_BUDGET_MS = 60_000;
export const URL_RE = /^\/pp\/([^/]+)\/potwierdzenia-zamowien\/([^/]+)\/?$/;
